import React from 'react'
import styled from 'styled-components'
import Image from '../basic/image'
import * as media from '../media'
import AutoPartCardBrief from '../finwhale/common/auto-part-card-brief'
import {compose, lifecycle, withState} from 'recompose'
import {getAttributes, getTemplate} from "../itemtype"
import _ from 'lodash'
import getUrl from "../getUrl";
import Loader from "../basic/LoaderCircle";
import getImgUrl from "../getImgUrl";
import InformationImage from '../static/information.svg'
import TranslateText from 'src/text/modal';


const selection = ({routeParams, cards, total, categoryCount, expanded, setExpanded, loadingCards}) => (
  <div>
    <div style={{width: '80%', margin: '0 auto', fontSize: '18px'}}>
      <p style={{textAlign: 'left', fontSize: 24, fontWeight: 800, marginTop: 40, marginBottom: 40}}>
        <TranslateText
          id="search__title"
          helperChips={{
              labels: [
                ['<<total>> - всего запчастей'],
                ['<<category-count>> - в категориях']
              ],
              example: 'Для указанного автомобиля найдено <<total>> запчастей в <<category-count>> категориях.'
            }}
            render={text => {
              text = text
                .replace('<<total>>', total || 0)
                .replace('<<category-count>>', categoryCount || 0);

              return <div>{text}</div>;
            }}
          />
      </p>

      {
        loadingCards ? <Loader/> :
          (expanded ? (cards || []) : []).map(c => {
            return (
              <AutoPartCardBrief
                img={getImgUrl(`/media/static/product_photos/${c.article}.png`)}
                href={`/item/${c.id}`}
                title={c.attribute_lang.display_name}
                output={c.output}
              />
            )
          })
      }

      <p
        style={{
          display: 'inline-block',
          textAlign: 'left',
          fontSize: 18,
          marginTop: 40,
          width: 550,
        }}
      >
        <Image
          src={InformationImage}
          width={35}
          containerStyle={{
            verticalAlign: 'top',
          }}
        />
        <span
          style={{
            marginLeft: 20,
            display: 'inline-block',
            width: 'calc(100% - 55px)',
            fontSize: '0.9em',
            verticalAlign: 'top',
          }}
        >
          <TranslateText
            id={'search__discrepancy'}
            style={{
              display: 'inline'
            }}
          />
        </span>
      </p>
    </div>
  </div>
)

const enhance = compose(
  lifecycle({
    state: {},

    componentDidUpdate(prevProps) {
      const nextArticle = _.get(this.props, 'routeParams.article')
      const prevArticle = _.get(prevProps, 'routeParams.article')
      if (prevArticle != nextArticle) {
        this.setState({loadingCards: true})
        fetch(getUrl(`/cat/v1/searchproduct/?article=${nextArticle}`)).then(data => {
          return data.json()
        }).then(listItems => {
          const ids = (_.get(listItems, 'data.data[0].id', '') || '').split(',')
          const promises = ids.reduce((result, id) => {
            if (id) {
              result.push(fetch(getUrl(`/cat/v1/item?id=${id}`)))
            }
            return result
          }, [])
          const whenCompleted = Promise.all(promises)
          whenCompleted.then((responses) => {
            const jsons = responses.map(data => data.json())
            Promise.all(jsons).then((jsons) => {
              let cards = jsons.map(e => _.get(e, 'data.data[0]'))
              const attributes = getAttributes(cards)
              cards = cards.map((c, i) => {
                const template = getTemplate(c.type_id);
                return {
                  ...c,
                  data: attributes[i],
                  output: {
                    article: {
                      key: template.code.title,
                      value: c.article,
                    },
                    weight: {
                      key: template.weight.title,
                      value: c.attribute_lang.weight,
                    },
                    size_package: {
                      key: template.size_package.title,
                      value: c.attribute_lang.size_package,
                    },
                    applicability: {
                      key: template.applicability.title,
                      value: c.attribute_lang.applicability,
                    },
                    complete: {
                      key: template.complete.title,
                      value: c.attribute_lang.complete,
                    },
                  },
                }
              })
              const categoryCount = Object.keys(_.groupBy(cards, 'type_name')).length
              this.setState({cards, total: cards.length, categoryCount, loadingCards: false})
            })
          })
        })
      }
    },
    componentDidMount() {
      const article = _.get(this.props, 'routeParams.article')
      this.setState({loadingCards: true})
      fetch(getUrl(`/cat/v1/searchproduct/?article=${article}`)).then(data => {
        return data.json()
      }).then(listItems => {
        const ids = (_.get(listItems, 'data.data[0].id', '') || '').split(',')
        const promises = ids.reduce((result, id) => {
          if (id) {
            result.push(fetch(getUrl(`/cat/v1/item?id=${id}`)))
          }
          return result
        }, [])
        const whenCompleted = Promise.all(promises)
        whenCompleted.then((responses) => {
          const jsons = responses.map(data => data.json())
          Promise.all(jsons).then((jsons) => {
            let cards = jsons.map(e => _.get(e, 'data.data[0]'))
            const attributes = getAttributes(cards)
            cards = cards.map((c, i) => {
              const template = getTemplate(c.type_id);
              return {
                ...c,
                data: attributes[i],
                output: {
                  article: {
                    key: template.code.title,
                    value: c.article,
                  },
                  weight: {
                    key: template.weight.title,
                    value: c.attribute_lang.weight,
                  },
                  size_package: {
                    key: template.size_package.title,
                    value: c.attribute_lang.size_package,
                  },
                  applicability: {
                    key: template.applicability.title,
                    value: c.attribute_lang.applicability,
                  },
                  complete: {
                    key: template.complete.title,
                    value: c.attribute_lang.complete,
                  },
                },
              }
            })
            const categoryCount = Object.keys(_.groupBy(cards, 'type_name')).length
            this.setState({cards, total: cards.length, categoryCount, loadingCards: false})
          })
        })
      }).catch(err => {
        console.log(err)
      })
    }
  }),
  withState('expanded', 'setExpanded', true)
)

export default enhance(selection)



// WEBPACK FOOTER //
// ./src/pages/searchByCode.js